module.exports = __webpack_public_path__ + "img/health-safe.09bd4ade.svg";